import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const fourYearsOldEquipment: BlogMetaData = {
  title: '4歳のモンテッソーリ教具おすすめ8選｜知育玩具との違い・選び方【保育士監修】',
  description:
    '4歳（年少）に合うモンテッソーリ教具を厳選8選で紹介。知育玩具との違い、自立心・集中力・論理的思考を育てる選び方の基準、年齢別の発達に寄り添ったおすすめを保育士監修・モンテ視点で解説します。',
  thumbnailUrl: '/img/blog-4-years-old-equipment.webp',
  filePath: buildBlogFilePath('4-years-old-equipment'),
  category: BLOG_CATEGORY.PLAY_TOOLS,
};
